import React from 'react';

import { Button } from '@eika/button';
import { ErrorCard, InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import piwik from '@/piwik/piwik';

import applePay from '@domain/digital-wallet/components/apple-pay/ApplePay.svg';
import tapToPay from '@domain/digital-wallet/components/apple-pay/TapToPay.svg';
import useText from '@hooks/use-text';

type Props = {
    children: React.ReactNode;
    isSuccess: boolean;
    isError: boolean;
    retry: () => void;
    done: () => void;
};

const ApplePayModalContent: React.FC<Props> = ({ children, retry, isError, done, isSuccess }) => {
    const text = useText();
    if (isError) {
        return (
            <ErrorCard
                isModal
                description={text.cardNotAddedToWallet}
                icon={<RichIcon type={RichIconTypes.NETTVERKSBRUDD_HARE} />}
                title={text.messageErrorText}
                className="apple-pay-modal__error-wrapper"
                data-testid="apple-pay-error-message"
                data-track-id={piwik.applePay.addToAppleWalletFailedRetry.dataTrackId}
                data-track-linkname={piwik.applePay.addToAppleWalletFailedRetry.dataTrackLinkname}
            >
                <Button onClick={retry}>{text.tryAgain}</Button>
            </ErrorCard>
        );
    }

    if (isSuccess) {
        return (
            <InfoCard
                className="apple-pay-modal__success-wrapper"
                data-testid="apple-pay-success-message"
                skipBackground
                img={<RichIcon className="apple-pay-modal__status-icon" type={RichIconTypes.FERDIG} />}
            >
                <InfoCard.TitleH3>{text.cardAddedToWallet}</InfoCard.TitleH3>
                <p className="apple-pay-modal__success-description">{text.appleWalletSuccessDescription}</p>
                <div className="apple-pay-modal__action-wrapper">
                    <img
                        style={{ '--action-img-width': '70px' } as React.CSSProperties}
                        className="apple-pay-modal__action-img"
                        src={tapToPay}
                        alt={text.tapToPay}
                    />
                    <img
                        style={{ '--action-img-width': '60px' } as React.CSSProperties}
                        className="apple-pay-modal__action-img"
                        src={applePay}
                        alt={text.applePay}
                    />
                </div>
                <Button onClick={done}>{text.done}</Button>
            </InfoCard>
        );
    }

    return children;
};

export default ApplePayModalContent;
